import { useApiQuery } from "@/api";
import { getFinanceLabMetrics } from "./FinanceLab.queries";
import { FinanceLabField } from "./FinanceLab.model";
import { useCallback, useState } from "react";
import { getLastValue } from "@/utils/metrics/metricsUtils";

export function useFinanceLabAboutCompany(): {
    aboutText: string;
    generationBuffer: string | undefined;
    isLoading: boolean;
    isError: boolean;
    clearBuffer: () => void;
} {
    const [generationBuffer, setGenerationBuffer] = useState<
        string | undefined
    >(undefined);

    const { data, isLoading, isError } = useApiQuery(getFinanceLabMetrics, {
        params: {
            labels: [FinanceLabField.ORGANIZATION_ABOUT],
        },
    });

    const aboutMetric = data?.find(
        (metric) =>
            metric.info.derived.label === FinanceLabField.ORGANIZATION_ABOUT,
    )?.values;

    const aboutText =
        getLastValue(aboutMetric)?.formattedValue ||
        getLastValue(aboutMetric)?.value.toString() ||
        "-";

    const clearBuffer = useCallback(() => {
        setGenerationBuffer(undefined);
    }, []);

    return {
        aboutText,
        generationBuffer,
        isLoading: isLoading || false,
        isError,
        clearBuffer,
    };
}
